var _ = require('underscore');
var TorsoView = require('backbone-torso/modules/View');
var secureMessageAccountBillTemplate = require('./secureMessageAccountBillTemplate.hbs');
var PaymentDetailsBillModalView = require('./../payment/PaymentDetailsBillModalView');
var UseModalBehavior = require('./../widget/modal/UseModalBehavior');

/**
 * Displays unpaid bill with account info.
 *
 * @class SecureMessageAccountBillView
 * @extends Torso.View
 * @constructor
 */
module.exports = TorsoView.extend({
  tagName: 'li',
  className: 'brec-list__item brec-list__item--top-border',
  attributes: {
    'data-account-bill': 'test'
  },
  template: secureMessageAccountBillTemplate,

  events: {
    'click [data-show-details-modal]': '_showEStatementModal'
  },

  behaviors: {
    useModalBehavior: {
      behavior: UseModalBehavior
    }
  },

  prepareFields: {
    serviceDateStart: function() {
      return this._getServiceDateParts().serviceDateStart;
    },
    serviceDateEnd: function() {
      return this._getServiceDateParts().serviceDateEnd;
    }
  },

  /**
   * @method initialize
   * @override
   */
  initialize: function() {
    _.bindAll(this, '_showEStatementModal');

    this._eStatementModalView = new PaymentDetailsBillModalView({model: this.model});
    this.checkAccountNumber();
  },

  /**
   * Parse the service date parts (start/end) from the bill's service date.
   * @method _getServiceDateParts
   * @returns {Object} an object with a serviceDateStart and a serviceDateEnd property for display.
   */
  _getServiceDateParts: function() {
    var billSecureMessageModel = this.model;
    var serviceDateInterval = billSecureMessageModel && billSecureMessageModel.get('billDTO.externalBill.serviceDate');

    var serviceDateParts = serviceDateInterval && serviceDateInterval.split('-');

    var hasServiceDateStart = serviceDateParts && serviceDateParts.length > 0;
    var serviceDateStart = hasServiceDateStart && serviceDateParts[0];

    var hasServiceDateEnd = serviceDateParts && serviceDateParts.length > 1;
    var serviceDateEnd = hasServiceDateEnd && serviceDateParts[1];

    return {
      serviceDateStart: serviceDateStart,
      serviceDateEnd: serviceDateEnd
    };
  },

  /**
   * Displays the e-statement modal.
   * @method _showEStatementModal
   * @param event {jQuery.Event} the event that triggered this function call.
   * @private
   */
  _showEStatementModal: function(event) {
    event.preventDefault();
    this.showModal(this._eStatementModalView);
  },

  /**
   * Check whether the bill has account number or not
   */
  checkAccountNumber: function() {
    var hasAccountNumber = !!this.model.get('billDTO.accountNumber');
    this.set('hasAccountNumber', hasAccountNumber);
  }
});
